import React from "react";
import { Grid } from "@material-ui/core/";
import Aux from "../../../hoc/Auxilliary";
import Event from "../../../components/Alumni/Event";

function EventPage(props) {
  return (
    <Aux>
      <Grid container>
        <Grid item container xs={11} sm={10} style={{ margin: "0 auto" }}>
          <Event {...props} />
        </Grid>
      </Grid>
    </Aux>
  );
}

export default EventPage;
